import ErrorBoundary from './ErrorBoundary';
import '../css/errorBoundary.scss';

export default ErrorBoundary;
